module.exports = __webpack_public_path__ + "static/03-73a7797597a0c0a9c4a14580609828d6.png";